import { render, staticRenderFns } from "./StackDrillCard.vue?vue&type=template&id=0debad2c&scoped=true&"
import script from "./StackDrillCard.vue?vue&type=script&lang=js&"
export * from "./StackDrillCard.vue?vue&type=script&lang=js&"
import style0 from "./StackDrillCard.vue?vue&type=style&index=0&id=0debad2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0debad2c",
  null
  
)

export default component.exports